export default {
  config: {
    app: '',
    api: process.env.VUE_APP_API_URL,
    gateway: {
      masterOrigins: process.env.VUE_APP_GATEWAY_ORIGINS,
      slaveId: '',
    },
    locale: 'en',
    timezoneOffset: 0,
    wheel: {},
  },
  infoMessage: null,
  platform: {},
  rounds: [],
  jackpots: [],
  tickets: [],
  ticketBets: [],
  channel: null,
  channels: [],
  ticketFilters: {},
  toolbarFilters: {},
  selectedFilters: {},
  paginationConfig: {},
  token: null,
  exportType: null,
  translations: {
    columnViewLabel: 'Column view',
    columnResetLabel: 'Reset',
    toolbarDateLabel: 'Date',
    toolbarChannelLabel: 'Channel',
    toolbarPaymentBetshopsLabel: 'Betshop',
    toolbarPaymentOperatorsLabel: 'Operator',
    toolbarPaymentCashRegistersLabel: 'Cash register',
    toolbarFirstNameLabel: 'First name',
    toolbarLastNameLabel: 'Last name',
    toolbarUserNameLabel: 'Username',
    toolbarStatusesLabel: 'Status',
    toolbarPlayersLabel: 'Player',
    toolbarChannelRetailLabel: 'Retail',
    toolbarChannelTerminalLabel: 'Terminal',
    toolbarChannelWebLabel: 'Web',
    toolbarChannelMobileLabel: 'Mobile',
    toolbarPanelSearchFilterLabel: 'Search filter',
    toolbarPanelNoFilterDataLabel: 'No data for this filter',
    toolbarPanelSelectAllLabel: 'Select all',
    toolbarPanelClearLabel: 'Clear',
    predefinedRangeChooseLabel: 'Or choose',
    predefinedRangeChooseRangeLabel: 'Choose predefined range',
    predefinedRangeCurrentDateLabel: 'Current date',
    predefinedRangePreviousDateLabel: 'Previous day',
    predefinedRangeCurrentWeekLabel: 'Current week',
    predefinedRangePreviousWeekLabel: 'Previous week',
    predefinedRangeCurrentMonthLabel: 'Current month',
    predefinedRangePreviousMonthLabel: 'Previous month',
    dateRangePickerStartDateLabel: 'Start date',
    dateRangePickerEndDateLabel: 'End date',
    dateRangePickerTodayLabel: 'Today',
    dateRangePickerSaveButtonLabel: 'Save',
    dateRangePickerClearButtonLabel: 'Clear',
    infoMessage: 'Info',
    invalidDateInfo: 'Invalid date',
    fieldDateFromLabel: 'Date from',
    fieldDateToLabel: 'Date to',
    fieldSearchLabel: 'Search',
    pickerCancelLabel: 'Cancel',
    pickerSaveLabel: 'Save',
    refreshSetGridLabel: 'Set grid auto reload',
    refreshNoRefreshLabel: 'No refresh',
    refreshFiveSecondsLabel: '5 seconds',
    refreshTenSecondsLabel: '10 seconds',
    refreshtThirtySecondsLabel: '30 seconds',
    refreshSixtySecondsLabel: '60 seconds',
    refreshFiveMinutesLabel: '5 minutes',
    tabsRoundsTitle: 'Rounds',
    tabsTicketsTitle: 'Tickets',
    tabsJackpotsTitle: 'Jackpots',
    tableHeaderTypeLabel: 'Type',
    tableHeaderStatusLabel: 'Status',
    tableHeaderIconLabel: 'Icon',
    tableHeaderValueLabel: 'Value',
    tableHeaderOddsLabel: 'Odds',
    tableHeaderIdLabel: 'ID',
    tableHeaderDisplayIdLabel: 'Display ID',
    tableHeaderResultLabel: 'Result',
    tableHeaderCreatedAtLabel: 'Created At',
    tableHeaderResolvedAtLabel: 'Resolved At',
    tableHeaderCanceledAtLabel: 'Canceled At',
    tableHeaderPaidOutAtLabel: 'Paid Out At',
    tableHeaderBarcodeLabel: 'Barcode',
    tableHeaderTotalPaymentLabel: 'Payment',
    tableHeaderTotalStakeLabel: 'Stake',
    tableHeaderTotalPaymentTaxLabel: 'Payment Tax',
    tableHeaderTotalPayoutLabel: 'Winnings',
    tableHeaderTotalPayoutAfterTaxLabel: 'Payout',
    tableHeaderTotalPayoutTaxLabel: 'Payout Tax',
    tableHeaderPayoutAfterTaxLabel: 'Payout After Tax',
    tableHeaderTotalPossiblePayoutTaxLabel: 'Maximum Payout Tax',
    tableHeaderTotalPossiblePayoutLabel: 'Maximum Winnings',
    tableHeaderRoundLabel: 'Round',
    tableHeaderRtpLabel: 'RTP (%)',
    tableHeaderPaymentBetshopNameLabel: 'Payment Betshop',
    tableHeaderPaymentOperatorNameLabel: 'Payment Operator',
    tableHeaderPayoutBetshopNameLabel: 'Payout Betshop',
    tableHeaderPayoutOperatorNameLabel: 'Payout Operator',
    tableHeaderCancelBetshopNameLabel: 'Cancel Betshop',
    tableHeaderCancelOperatorNameLabel: 'Cancel Operator',
    tableHeaderPaymentRetailRegisterNameLabel: 'Cash register name',
    tableHeaderPaymentRetailRegisterIdLabel: 'Cash register uuid',
    tableHeaderPlayerIdLabel: 'Player Uuid',
    tableHeaderPlayerUsernameLabel: 'Player Username',
    tableHeaderJackpotWinAmountLabel: 'Jackpot Win',
    tableNoDataText: 'No data available for selected parameters',
    tableNoResultsText: 'No matching records found for given parameters',
    tableRowsPerPageText: 'Page size',
    tableTotalResultsText: 'Total results',
    tableFiltersColumnsText: 'You can\'t add more columns.',
    filtersLabel: 'Filters',
    resetFiltersLabel: 'Reset filters',
    exportLabel: 'Export',
    maxAllowedDaysText: 'Please select a date range of 31 days or less',
    ticketStatusClosed: 'Closed',
    ticketStatusOpen: 'Open',
    ticketStatusLost: 'Lost',
    ticketStatusWon: 'Won',
    ticketStatusPending: 'Pending',
    ticketStatusPaidOut: 'Paidout',
    ticketStatusWonExpired: 'Won expired',
  },
  ui: {},
  user: {},
};
